import { z } from "zod";

import { SmileSimulationSchema } from "./schema.js";

export const SmileSimulationEntitySchema = SmileSimulationSchema.extend({
  id: z.string().trim().min(1),
});

export type SmileSimulationEntity = z.infer<typeof SmileSimulationEntitySchema>;
